import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import { mapGMSField } from './gridUtils';
import { getProjection } from './projectionUtils';
import { getCriteriaChain } from './criteriaChainUtils';

const getMostCommonColumns = (columns, preferredColumns) => {
  const mostCommonColumns = [];

  preferredColumns.forEach((item) => {
    const preferredColumn = columns.find((column) => column.field === item);

    if (preferredColumn) {
      mostCommonColumns.push(preferredColumn);
    }
  });

  return [...new Set(mostCommonColumns)];
};

export const getLookupExtraParams = ({
  entity,
  defaultField,
  customPayload = {},
  ...rest
}) => {
  const result = {
    setDefaultColumns: (columns, updateColumns) => {
      const defaultColumns = getMostCommonColumns(columns, [
        defaultField,
        'key',
        'name',
        'description',
        'organization'
      ]);

      if (defaultColumns.length === 5) {
        updateColumns(defaultColumns);
      } else {
        const fromIndex = defaultColumns.length;
        const restColumns = columns.slice(fromIndex, 5);

        updateColumns([...defaultColumns, ...restColumns]);
      }
    },
    onRequestFields: async () => {
      const url = `/form/${entity}/Fields`;

      const entityFields = await defaultFetch(url);
      if (!entityFields) return [];
      
      const fields = await Promise.all(entityFields?.map(mapGMSField));

      return fields;
    },
    onRequestData: async (parameters, table) => {
      const { activeFields = [], payload, fields: lookupFields } = parameters;
      const finalPayload = {
        ...payload,
        ...customPayload
      };

      if (entity === 'Organization') {
        const listenerOrganization = activeFields.findIndex(
          (item) => item.name === 'listenerOrganizations'
        );
        activeFields.splice(listenerOrganization, 1);
      }

      const firstResult = table?.getData()?.length ?? 0;
      const projection = getProjection(firstResult, activeFields);
      const criteriaChain = getCriteriaChain(finalPayload, lookupFields, true);

      const url = `/${entity}/restrictions?criteria=${encodeURI(
        JSON.stringify(projection)
      )}`;

      return defaultFetch(url, criteriaChain, 'POST');
    },
    defaultField,
    ...rest
  };

  return result;
};
